import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../utils/apiClient";
import UploadWidget from "../UploadWidget";
import AddElement from "../AddElement";
import Navbar from "../Navbar";
import Foooter from "../Foooter";
import FooterMovil from "../FooterMovil";
import { AdminSidebar, AdminSidebarDropdown } from "../AdminSidebar";
import ModalDelete from "../ModalDelete";
import "../../style/AddCar.css";
import { useAuth } from "../../context/AuthContext.js";
import LoadingBar from 'react-top-loading-bar';
import { notification } from 'antd';

function AddCar() {
  const [loading, setLoading] = useState(false);
  const ref = useRef(null);

  const [showPopup, setShowPopup] = useState(false);
  const [showPop, setShowPop] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [modelos, setModelos] = useState([]);
  const [username, setUsername] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedModel, setSelectedModel] = useState("");
  const [selectedBrandID, setSelectedBrandID] = useState("");
  const [selectedUBI, setSelectedUBI] = useState("");
  const [selectedgastype, setSelectedgastype] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedCondition, setSelectedCondition] = useState("");
  const [selectedTrans, setSelectedTrans] = useState("");
  const [selectedTrac, setSelectedTrac] = useState("");
  const [Link, setLink] = useState("");
  const [Link2, setLink2] = useState("");
  const [images, setImages] = useState([]);
  const [brandImage, setBrandImage] = useState(null);
  const [mainImage, setMainImage] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [imageToDelete, setImageToDelete] = useState(null);

  const showErrorNotification = (message) => {
    notification.error({
      message: 'Error de validación',
      description: message,
      placement: 'topRight',
    });
  };

  const validateFields = () => {
    if (images.length === 0) {
      showErrorNotification("Hace falta foto.");
      return false;
    }
    if (!selectedBrand) {
      showErrorNotification("Hace falta seleccionar una marca.");
      return false;
    }
    if (!selectedModel) {
      showErrorNotification("Hace falta seleccionar un modelo.");
      return false;
    }
    if (!inputValues.anio) {
      showErrorNotification("Hace falta ingresar el año.");
      return false;
    }
    if (!inputValues.millaje) {
      showErrorNotification("Hace falta ingresar el millaje.");
      return false;
    }
    if (!inputValues.precio) {
      showErrorNotification("Hace falta ingresar el precio.");
      return false;
    }
    if (!selectedUBI) {
      showErrorNotification("Hace falta seleccionar la ubicación.");
      return false;
    }
    if (!selectedCondition) {
      showErrorNotification("Hace falta seleccionar la condición.");
      return false;
    }
    if (!inputValues.motor) {
      showErrorNotification("Hace falta ingresar el motor.");
      return false;
    }
    if (!selectedgastype) {
      showErrorNotification("Hace falta seleccionar el tipo de combustible.");
      return false;
    }
    if (!selectedTrans) {
      showErrorNotification("Hace falta seleccionar la transmisión.");
      return false;
    }
    if (!selectedTrac) {
      showErrorNotification("Hace falta seleccionar la tracción.");
      return false;
    }
    if (!selectedType) {
      showErrorNotification("Hace falta seleccionar el tipo de vehículo.");
      return false;
    }
    if (!inputValues.lote) {
      showErrorNotification("Hace falta ingresar el lote.");
      return false;
    }
    return true;
  };
  

  const { authToken, logout } = useAuth();
  const navigate = useNavigate();

  const togglePop = () => setShowPop(!showPop);
  const togglePopup = () => setShowPopup(!showPopup);

  const handleSelectMainImage = (url) => {
    setMainImage(url);
  };

  const handleDeleteImage = (url) => {
    setImageToDelete(url);
    setShowDeleteModal(true);
  };

  const confirmDeleteImage = () => {
    setImages((prevImages) =>
      prevImages.filter((image) => image !== imageToDelete)
    );
    if (mainImage === imageToDelete) {
      setMainImage(images[0] || null);
    }
    setShowDeleteModal(false);
    setImageToDelete(null);
  };

  const cancelDeleteImage = () => {
    setShowDeleteModal(false);
    setImageToDelete(null);
  };

  const getMarcas = async () => {
    try {
      const res = await api.get("marcasymodelos/marca");
      setMarcas(res.data);
    } catch (error) {
      console.error("Error fetching marcas:", error);
    }
  };

  const getuser = async () => {
    try {
      const response = await api.get("usuario/getbyToken");
      setUsername(response.data.nombre);
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };

  useEffect(() => {
    const inicio = async () => {
      await getMarcas();

      if (!authToken) {
        navigate("/");
      } else {
        await getuser();
      }
    };

    inicio();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken, navigate]);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const gastypes = ["Gasolina", "Disel", "N/A"];
  const typecars = [
    "Camioncito",
    "Pick Up",
    "Sedan",
    "Camioneta",
    "Cabezal",
    "Bus",
    "Camion",
    "Motocicleta",
    "Varios"
  ];
  const transmisiones = ["Automatica", "Mecánica", "N/A"];
  const tracciones = ["Delantera", "Trasera", "4x4", "N/A"];
  const condiciones = ["Chocado", "Arreglado", "Buen Estado"];
  const Ubications = [
    "USA",
    "Puerto Cortez",
    "Tegucigalpa",
    "Transito",
    "San Lorenzo",
  ];

  const getmodelos = async (marcaID) => {
    try {
      const data = { marca: marcaID };
      const res = await api.post("marcasymodelos/modelobymarca", data);
      setModelos(res.data);
    } catch (error) {
      console.error("Error fetching modelos:", error);
    }
  };

  const handleBrandChange = (event) => {
    setSelectedBrand(event.target.value);
    const result = marcas.filter(
      (marca) => marca.Nombre === event.target.value
    );
    setSelectedBrandID(result[0]._id);
    getmodelos(result[0]._id);
  };

  const HandleBrandChangeUpdate = async (Brand) => {
    try {
      const res = await api.get("marcasymodelos/marca");
      const brands = res.data;
      const result = brands.filter((brand) => brand.Nombre === Brand);
      setSelectedBrandID(result[0]._id);
      getmodelos(result[0]._id);
    } catch (error) {
      console.error("Error fetching marca for update:", error);
    }
  };

  const handleModelChange = (event) => setSelectedModel(event.target.value);
  const handleTransChange = (event) => setSelectedTrans(event.target.value);
  const handleTracChange = (event) => setSelectedTrac(event.target.value);
  const handleConditionChange = (event) =>
  setSelectedCondition(event.target.value);
  const handleTypeChange = (event) => setSelectedType(event.target.value);
  const handleUBIChange = (event) => setSelectedUBI(event.target.value);
  const handleGasChange = (event) => setSelectedgastype(event.target.value);
  const handleURIChange = (event) => setLink(event.target.value);
  const handleURIChange2 = (event) => setLink2(event.target.value);

  const handleUploadSuccess = (url) => {
    setImages((prevImages) => [...prevImages, url]);
    setImageUrls((prevImages) => [...prevImages, url]);
    if (images.length === 0) {
      setMainImage(url);
    }
  };

  const handleBrandUploadSuccess = (url) => {
    setBrandImage(url);
  };

  const [inputValues, setInputValues] = useState({
    marca: "",
    modelo : "",
    millaje: "",
    precio: "",
    motor: "",
    anio: "",
    comentario: "",
    enlace: "",
    listado: "",
    precioOferta: "",
    lote: "",
  });

  const [marcainput, setMarca] = useState("");
  const [modeloinput, setModelo] = useState("");

  const handlemarcaChange = (event) => setMarca(event.target.value);
  const handlemodeloChange = (event) => setModelo(event.target.value);

  const [checkboxes, setCheckboxes] = useState({
    iaai: false,
    copart: false,
    grua: false,
    costosintro: false,
    enciende: false,
    camina: false,
    costosvias: false,
    costosins: false,
    placas: false,
    destacado: false,
    inscripcion: false,
  });

  const handleCheckboxChange = async (event) => {
    const { name, checked } = event.target;
    setCheckboxes((prevCheckboxes) => ({ ...prevCheckboxes, [name]: checked }));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setInputValues((prevValues) => ({ ...prevValues, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validar los campos antes de proceder

  if(selectedType !== 'Varios'){
    if (!validateFields()) {
      return;
    }
  }
  

    const filteredArray = imageUrls.filter(
      (item) =>
        item !== null &&
        item !== undefined &&
        item !== "" &&
        !(Array.isArray(item) && item.length === 0)
    );

    
    const carData = {
      ...inputValues,
      motor: inputValues.motor || "0",
      lote: inputValues.lote || "0",
      imagenes: filteredArray,
      condicion: selectedCondition,
      marca: selectedBrand || inputValues.marca,
      modelo: selectedModel || inputValues.modelo || '-',
      tipo: selectedType,
      traccion: selectedTrac,
      transmission: selectedTrans,
      ubicacion: selectedUBI,
      combustible: selectedgastype,
      millaje: parseInt(inputValues.millaje) || 0,
      anio: parseInt(inputValues.anio),
      precio: parseInt(inputValues.precio),
      camina: checkboxes.camina,
      Introduccion: checkboxes.costosintro,
      enciende: checkboxes.enciende,
      viasPublicas: checkboxes.costosvias,
      gruaIncluida: checkboxes.grua,
      costosPlacas: checkboxes.placas,
      destacado: checkboxes.destacado,
      gastosDeInscripcion: checkboxes.costosins,
    };

    try {
      await api.post(`carro/`, carData);
      navigate("/allcarsa");
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  function capitalizeFirstLetter(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  const handleMarcaAdd = async () => {
    const datamarca = { Nombre: marcainput, Imagen: brandImage };
    await api.post("marcasymodelos/marca", datamarca);
    setMarca("");
    setSelectedBrand("");
    setBrandImage(null);
    setBrandImage(null);
    togglePopup();
    getMarcas();
  };

  const handleModeloAdd = async () => {
    const datamodelo = { Nombre: modeloinput, Marca: selectedBrandID };
    await api.post("marcasymodelos/modelo", datamodelo);
    togglePop();
    getmodelos(selectedBrandID);
    setSelectedModel("");
  };

  function convertToCC(input) {
    const match = input.match(/(\d+(\.\d+)?)L/);
    if (match) {
        const liters = parseFloat(match[1]);
        const cc = liters * 1000;
        return cc;
    } else {
        throw new Error("Input string does not match the expected format");
    }
  }


  const handleWebScrape = async () => {
    if (checkboxes.iaai) {
      setLoading(true);
      ref.current.continuousStart(); // Start loading bar
      try {
        const cardata = await api.post("webscraping/iaai", {
          identifier: Link,
          identifier2: Link2,
        });
        setImages(cardata.data.imagenes)
        setImageUrls(cardata.data.imagenes);
        setSelectedBrand(capitalizeFirstLetter(cardata.data.marca));
        await HandleBrandChangeUpdate(capitalizeFirstLetter(cardata.data.marca));
        setInputValues({
          anio: cardata.data.anio,
          lote: cardata.data.lote,
          enlace: cardata.data.Link360
        });
      } catch (error) {
        console.error(error);
        notification.error({
          message: 'Error al realizar web scraping en IAAI',
          description: 'Ocurrió un error al intentar realizar el web scraping en IAAI. Por favor, inténtelo de nuevo más tarde.',
        });
      } finally {
        setLoading(false);
        ref.current.complete(); // Complete loading bar
      }
    }
    if (checkboxes.copart) {
      try {
        setLoading(true);
        ref.current.continuousStart();
        const data = {
          identifier: Link
        }
        const cardata = await api.post("webscraping/copartInit", data);
        const odometroValue = (cardata.data.datos.odometro).split(' ')
        const CCvalue = convertToCC(cardata.data.datos.motor)
        setImages(cardata.data.imagenes)
        setInputValues({
          millaje: odometroValue[0],
          motor: CCvalue.toString(),
          anio: cardata.data.datos.anio,
          lote: cardata.data.datos.lotnum,
        });
        setImageUrls(cardata.data.imagenes);
        setSelectedBrand(capitalizeFirstLetter(cardata.data.datos.marca));
        await HandleBrandChangeUpdate(capitalizeFirstLetter(cardata.data.datos.marca));
      } catch (error) {
        console.error(error);
        notification.error({
          message: 'Error al realizar web scraping en Copart',
          description: 'Ocurrió un error al intentar realizar el web scraping en Copart. Por favor, inténtelo de nuevo más tarde.',
        });
      } finally {
        setLoading(false);
        ref.current.complete(); // Complete load
      }
    }
  };
  

  const pickSource = (source) => {
    setCheckboxes((prev) => ({
      ...prev,
      iaai: source === "iaai" ? !prev.iaai : false,
      copart: source === "copart" ? !prev.copart : false,
    }));
  };

  const featureChips = [
    { name: "grua", label: "Grúa incluida" },
    { name: "costosintro", label: "Costos de introducción" },
    { name: "costosins", label: "Costos de inscripción" },
    { name: "costosvias", label: "Costos de vías públicas" },
    { name: "placas", label: "Costos de placas" },
    { name: "destacado", label: "Destacado" },
    { name: "enciende", label: "Enciende" },
    { name: "camina", label: "Camina" },
  ];

  return (
    <>
      <Navbar />
      <div className="containers ac-page">
        <div className="main-container-admin-add">
          <AdminSidebar username={username} onLogout={handleLogout} />
          <div className="column-info-all">
            <AdminSidebarDropdown onLogout={handleLogout} />
            <p className="main-user-title">Agregar Auto</p>
            <form onSubmit={handleSubmit} className="form-container-add ac-form">
              <LoadingBar color="#db3a34" ref={ref} className="top-loading-bar" />

              {/* Scraping section */}
              <section className="ac-card">
                <header className="ac-card-header">
                  <h2 className="ac-card-title">Importación automática</h2>
                  <p className="ac-card-sub">
                    Pega el link de la subasta para autollenar marca, año, millaje, imágenes, etc.
                  </p>
                </header>

                <div className="ac-scraping-grid">
                  <div className="ac-field">
                    <label className="ac-label">Fuente</label>
                    <div className="ac-toggle-group" role="radiogroup" aria-label="Fuente de importación">
                      <button
                        type="button"
                        className={`ac-toggle ${checkboxes.iaai ? "is-active" : ""}`}
                        onClick={() => pickSource("iaai")}
                        role="radio"
                        aria-checked={checkboxes.iaai}
                      >
                        IAAI
                      </button>
                      <button
                        type="button"
                        className={`ac-toggle ${checkboxes.copart ? "is-active" : ""}`}
                        onClick={() => pickSource("copart")}
                        role="radio"
                        aria-checked={checkboxes.copart}
                      >
                        Copart
                      </button>
                    </div>
                  </div>

                  <div className="ac-field ac-field-wide">
                    <label className="ac-label" htmlFor="Link">Link de la subasta</label>
                    <input
                      id="Link"
                      type="text"
                      name="Link"
                      value={Link}
                      onChange={handleURIChange}
                      className="ac-input"
                      placeholder="https://www.iaai.com/... o https://www.copart.com/..."
                    />
                  </div>

                  {checkboxes.iaai && (
                    <div className="ac-field ac-field-wide">
                      <label className="ac-label" htmlFor="Link2">Link 2 (IAAI)</label>
                      <input
                        id="Link2"
                        type="text"
                        name="Link2"
                        value={Link2}
                        onChange={handleURIChange2}
                        className="ac-input"
                        placeholder="Enlace secundario"
                      />
                    </div>
                  )}

                  <div className="ac-field ac-field-actions">
                    <button
                      type="button"
                      className="ac-btn ac-btn-primary"
                      onClick={handleWebScrape}
                      disabled={(!checkboxes.iaai && !checkboxes.copart) || loading}
                    >
                      <img src="images/fire-icon.png" alt="" className="ac-btn-icon" />
                      {loading ? "Importando..." : "Importar datos"}
                    </button>
                  </div>
                </div>
              </section>

              {/* Images section */}
              <section className="ac-card">
                <header className="ac-card-header">
                  <h2 className="ac-card-title">Imágenes</h2>
                  <p className="ac-card-sub">
                    Haz clic en una miniatura para elegirla como imagen principal.
                  </p>
                </header>

                <div className="ac-upload">
                  <UploadWidget onUploadSuccess={handleUploadSuccess} />
                </div>

                {images.length > 0 ? (
                  <div className="ac-images">
                    <div className="ac-image-main">
                      <img src={mainImage || images[0]} alt="Principal" />
                      <span className="ac-image-main-badge">Principal</span>
                    </div>
                    <div className="ac-image-thumbs">
                      {images.map((url, index) => (
                        <div
                          key={index}
                          className={`ac-thumb ${mainImage === url ? "is-main" : ""}`}
                        >
                          <img
                            src={url}
                            alt={`Imagen ${index + 1}`}
                            onClick={() => handleSelectMainImage(url)}
                          />
                          <button
                            type="button"
                            className="ac-thumb-delete"
                            onClick={() => handleDeleteImage(url)}
                            aria-label="Eliminar imagen"
                          >
                            ✕
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <p className="ac-empty">Aún no has subido imágenes</p>
                )}
              </section>

              {/* Vehicle info section */}
              <section className="ac-card">
                <header className="ac-card-header">
                  <h2 className="ac-card-title">Información del vehículo</h2>
                  <p className="ac-card-sub">
                    Selecciona marca y modelo. Usa el botón + para agregar uno nuevo.
                  </p>
                </header>

                <div className="ac-form-grid">
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="marca">Marca</label>
                    <div className="ac-input-with-btn">
                      {selectedType !== "Varios" ? (
                        <select
                          id="marca"
                          name="marca"
                          className="ac-select"
                          value={selectedBrand}
                          onChange={handleBrandChange}
                        >
                          <option value="">Selecciona marca</option>
                          {marcas.map((marca) => (
                            <option key={marca._id} value={marca.Nombre}>
                              {marca.Nombre}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <input
                          id="marca"
                          name="marca"
                          type="text"
                          className="ac-input"
                          placeholder="Marca"
                          value={inputValues.marca}
                          onChange={handleInputChange}
                        />
                      )}
                      {selectedType !== "Varios" && (
                        <button
                          type="button"
                          className="ac-plus-btn"
                          onClick={togglePopup}
                          aria-label="Agregar nueva marca"
                        >
                          +
                        </button>
                      )}
                    </div>
                    <AddElement show={showPopup} handleClose={togglePopup}>
                      <div className="ac-popup">
                        <h3 className="ac-popup-title">Agregar nueva marca</h3>
                        <input
                          type="text"
                          name="marcainput"
                          id="marcainput"
                          onChange={handlemarcaChange}
                          className="ac-input"
                          placeholder="Nombre de la marca"
                        />
                        <UploadWidget onUploadSuccess={handleBrandUploadSuccess} />
                        <button
                          onClick={handleMarcaAdd}
                          type="button"
                          className="ac-btn ac-btn-primary"
                        >
                          Agregar marca
                        </button>
                      </div>
                    </AddElement>
                  </div>

                  <div className="ac-field">
                    <label className="ac-label" htmlFor="modelo">Modelo</label>
                    <div className="ac-input-with-btn">
                      {selectedType !== "Varios" ? (
                        <select
                          id="modelo"
                          name="modelo"
                          className="ac-select"
                          value={selectedModel}
                          onChange={handleModelChange}
                        >
                          <option value="">Selecciona modelo</option>
                          {modelos.map((modelo) => (
                            <option key={modelo._id} value={modelo.Nombre}>
                              {modelo.Nombre}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <input
                          id="modelo"
                          name="modelo"
                          type="text"
                          className="ac-input"
                          placeholder="Modelo"
                          value={inputValues.modelo}
                          onChange={handleInputChange}
                        />
                      )}
                      {selectedType !== "Varios" && (
                        <button
                          type="button"
                          className="ac-plus-btn"
                          onClick={togglePop}
                          aria-label="Agregar nuevo modelo"
                        >
                          +
                        </button>
                      )}
                    </div>
                    <AddElement show={showPop} handleClose={togglePop}>
                      <div className="ac-popup">
                        <h3 className="ac-popup-title">Agregar nuevo modelo</h3>
                        <input
                          type="text"
                          name="modeloinput"
                          id="modeloinput"
                          onChange={handlemodeloChange}
                          className="ac-input"
                          placeholder="Nombre del modelo"
                        />
                        <button
                          onClick={handleModeloAdd}
                          type="button"
                          className="ac-btn ac-btn-primary"
                        >
                          Agregar modelo
                        </button>
                      </div>
                    </AddElement>
                  </div>

                  <div className="ac-field">
                    <label className="ac-label" htmlFor="anio">Año</label>
                    <input
                      id="anio"
                      name="anio"
                      type="text"
                      inputMode="numeric"
                      className="ac-input"
                      placeholder="2015"
                      value={inputValues.anio}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="millaje">Millaje</label>
                    <input
                      id="millaje"
                      name="millaje"
                      type="text"
                      inputMode="numeric"
                      className="ac-input"
                      placeholder="85,000"
                      value={inputValues.millaje}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="ac-field">
                    <label className="ac-label" htmlFor="precio">Precio (L)</label>
                    <input
                      id="precio"
                      name="precio"
                      type="text"
                      inputMode="numeric"
                      className="ac-input"
                      placeholder="250,000"
                      value={inputValues.precio}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="ubicacion">Ubicación</label>
                    <select
                      id="ubicacion"
                      name="ubicacion"
                      className="ac-select"
                      value={selectedUBI}
                      onChange={handleUBIChange}
                    >
                      <option value="">Selecciona ubicación</option>
                      {Ubications.map((ubication) => (
                        <option key={ubication} value={ubication}>
                          {ubication}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="ac-field">
                    <label className="ac-label" htmlFor="condicion">Condición</label>
                    <select
                      id="condicion"
                      name="condicion"
                      className="ac-select"
                      value={selectedCondition}
                      onChange={handleConditionChange}
                    >
                      <option value="">Selecciona condición</option>
                      {condiciones.map((condicion) => (
                        <option key={condicion} value={condicion}>
                          {condicion}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="motor">Motor (cc)</label>
                    <input
                      id="motor"
                      name="motor"
                      type="text"
                      inputMode="numeric"
                      className="ac-input"
                      placeholder="1800"
                      value={inputValues.motor}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="ac-field">
                    <label className="ac-label" htmlFor="combustible">Combustible</label>
                    <select
                      id="combustible"
                      name="combustible"
                      className="ac-select"
                      value={selectedgastype}
                      onChange={handleGasChange}
                    >
                      <option value="">Selecciona combustible</option>
                      {gastypes.map((g) => (
                        <option key={g} value={g}>{g}</option>
                      ))}
                    </select>
                  </div>
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="transmision">Transmisión</label>
                    <select
                      id="transmision"
                      name="transmision"
                      className="ac-select"
                      value={selectedTrans}
                      onChange={handleTransChange}
                    >
                      <option value="">Selecciona transmisión</option>
                      {transmisiones.map((t) => (
                        <option key={t} value={t}>{t}</option>
                      ))}
                    </select>
                  </div>

                  <div className="ac-field">
                    <label className="ac-label" htmlFor="traccion">Tracción</label>
                    <select
                      id="traccion"
                      name="traccion"
                      className="ac-select"
                      value={selectedTrac}
                      onChange={handleTracChange}
                    >
                      <option value="">Selecciona tracción</option>
                      {tracciones.map((t) => (
                        <option key={t} value={t}>{t}</option>
                      ))}
                    </select>
                  </div>
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="tipo">Tipo</label>
                    <select
                      id="tipo"
                      name="tipo"
                      className="ac-select"
                      value={selectedType}
                      onChange={handleTypeChange}
                    >
                      <option value="">Selecciona tipo</option>
                      {typecars.map((t) => (
                        <option key={t} value={t}>{t}</option>
                      ))}
                    </select>
                  </div>

                  <div className="ac-field ac-field-full">
                    <label className="ac-label" htmlFor="lote">Lote</label>
                    <input
                      id="lote"
                      name="lote"
                      type="text"
                      className="ac-input"
                      placeholder="Número de lote"
                      value={inputValues.lote}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </section>

              {/* Additional details */}
              <section className="ac-card">
                <header className="ac-card-header">
                  <h2 className="ac-card-title">Detalles adicionales</h2>
                </header>

                <div className="ac-form-grid">
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="comentario">Comentario</label>
                    <input
                      id="comentario"
                      name="comentario"
                      type="text"
                      className="ac-input"
                      placeholder="Notas internas"
                      value={inputValues.comentario}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="listado">Listado</label>
                    <input
                      id="listado"
                      name="listado"
                      type="text"
                      className="ac-input"
                      placeholder="Listado"
                      value={inputValues.listado}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="enlace">Enlace 306</label>
                    <input
                      id="enlace"
                      name="enlace"
                      type="text"
                      className="ac-input"
                      placeholder="https://..."
                      value={inputValues.enlace}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="precioOferta">Precio oferta (L)</label>
                    <input
                      id="precioOferta"
                      name="precioOferta"
                      type="text"
                      inputMode="numeric"
                      className="ac-input"
                      placeholder="180,000"
                      value={inputValues.precioOferta}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </section>

              {/* Features checkboxes */}
              <section className="ac-card">
                <header className="ac-card-header">
                  <h2 className="ac-card-title">Incluye / características</h2>
                  <p className="ac-card-sub">
                    Marca todas las opciones aplicables.
                  </p>
                </header>

                <div className="ac-checks-grid">
                  {featureChips.map((item) => (
                    <label
                      key={item.name}
                      className={`ac-check-chip ${checkboxes[item.name] ? "is-checked" : ""}`}
                    >
                      <input
                        type="checkbox"
                        name={item.name}
                        checked={checkboxes[item.name]}
                        onChange={handleCheckboxChange}
                      />
                      <span className="ac-check-mark" aria-hidden="true">✓</span>
                      <span className="ac-check-label">{item.label}</span>
                    </label>
                  ))}
                </div>
              </section>

              <div className="ac-submit-row">
                <button type="submit" className="ac-btn ac-btn-primary ac-btn-lg">
                  Agregar auto
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="footer">
      <Foooter />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
      <ModalDelete
        show={showDeleteModal}
        onClose={cancelDeleteImage}
        onConfirm={confirmDeleteImage}
      />
    </>
  );
}

export default AddCar;
